import { render } from "./AccountsListItemCreate.vue?vue&type=template&id=23916cda"
import script from "./AccountsListItemCreate.vue?vue&type=script&lang=js"
export * from "./AccountsListItemCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__